/* import __COLOCATED_TEMPLATE__ from './onfido-react.hbs'; */
import Component from '@glimmer/component';

import { Onfido } from '@repo/kyc';

export default class OnfidoReact extends Component {
  onfido = Onfido;
}
